import type { IErrorApiResponse, ISuccessApiResponse } from '@wyz/types';
import {
  OverridableQuery,
  UseQueryOptions,
  emptyQueryError,
  restrictApi,
  serialize,
  useQuery,
} from '@wyz/utils';
import { useApi, useConfig } from '~/common/context';
import { PurchaseQueryKeys } from '~/purchase/api';
import { usePurchaseContext } from '~/purchase/context';
import { IQuoteProximityStock } from '~/purchase/types';
type Options = {
  getProximityStocks?: OverridableQuery<
    UseQueryOptions<
      ISuccessApiResponse<IQuoteProximityStock[]>,
      IErrorApiResponse
    >
  > & { args: { identifiers: string[] } };
};
export const useManageQuoteStock = <
  TRequestedKeys extends keyof Options,
  TRequestedOptions extends Options = Pick<Options, TRequestedKeys>,
>(
  options: TRequestedOptions,
) => {
  const { callCoreApi } = useApi();
  const { state } = usePurchaseContext();
  const { tenantCode } = useConfig();
  const idCustomer = state.targetCustomer?.id as string;
  const getQuery = useQuery({
    queryKey: PurchaseQueryKeys.quoteProximityStocks.base(
      idCustomer,
      options.getProximityStocks?.args.identifiers ?? [],
    ),
    queryFn: () =>
      idCustomer
        ? callCoreApi<ISuccessApiResponse<IQuoteProximityStock[]>>(
            `/offers/api/tenants/${tenantCode}/customers/${idCustomer}/proximity-stocks?${serialize(options.getProximityStocks?.args)}`,
          )
        : emptyQueryError(),
    gcTime: 0,
    refetchOnWindowFocus: false,
    enabled: Boolean(idCustomer) && options.getProximityStocks?.enabled,
  });
  return restrictApi(options, {
    getProximityStocks: getQuery,
  });
};
